import { JustificationModalComponent } from './shared/modals/justificationModal/justificationModal.component';
import { SharedModule } from './shared/modules/shared.module';
import { BaseModule } from './shared/modules/base/base.module';
import { AuthBaseService } from './services/auth/auth-base.service';
//core
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';

//init
import { AppComponent } from './app.component';
//components
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AlertModalComponent } from './shared/modals/alertModal/alertModal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComponentsModule } from './shared/components/components.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { AlertModalCancelComponent } from './shared/modals/alertModalCancel/alertModalCancel.component';
import { ReasonModalComponent } from './shared/modals/reasonModal/reasonModal.component';
import { ConfirmModalComponent } from './shared/modals/confirmModal/confirmModal.component';
import { MaterialBaseModule } from './shared/modules/material-base.module';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

//ng-module
@NgModule({
  declarations: [
    AppComponent,
    AlertModalComponent,
    AlertModalCancelComponent,
    ConfirmModalComponent,
    ReasonModalComponent,
    JustificationModalComponent
  ],
  imports: [
    SharedModule,
    AppRoutingModule,
    NgxMaskDirective,
    NgxMaskPipe,
    BaseModule,
    NgSelectModule,
    ComponentsModule,
    NgxPaginationModule,
    FormsModule,
    MaterialBaseModule
  ],
  providers: [
    AuthBaseService,
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    provideNgxMask(),
  ],
  bootstrap: [
    AppComponent
  ],
})
export class AppModule { }